// ----------------------------------------------------------------------------

function layouts(element: HTMLElement): any[] {
    const arr: any[] = [];
    const elTableBody = element.querySelector('tbody');

    if (!elTableBody) {
        return arr;
    }

    const listRow = Array.from(elTableBody.rows);

    for (let r = 0; r < listRow.length; r++) {
        const elRow = listRow[r];
        const listCell = Array.from(elRow.cells);

        for (let c = 0; c < listCell.length; c++) {
            const elColumn = listCell[c];
            const id = 'T' + r + c;
            const element = elColumn.querySelector('div');

            element?.setAttribute('id', id);

            arr.push({
                element: element,
                row: r,
                column: c,
            });
        }
    }

    return arr;
}

const reset = {
    layouts,
};

// ----------------------------------------------------------------------------

export { layouts, reset };
